import Notification from "../../components/Sewa/Dashboard.js/Notification";
import AdminLayout from "../../layout/AdminLayoutSewa";

const QR = () =>{
    return(
        <AdminLayout>
        <div>
            <Notification/>
        </div>
        </AdminLayout>
    );
}
export default QR;
